import { RefObject, useEffect } from "react";

export function useFocusInput(inputRef: RefObject<HTMLInputElement>) {
  useEffect(() => {
    inputRef.current?.focus();
  }, [inputRef]);
}
